import {createSlice} from '@reduxjs/toolkit';
import {getAnnouncements} from './thunks';

const initialState = {
  announcements: [],
  announcementsHidden: !!JSON.parse(localStorage.getItem('announcements-hidden')),
};

const slice = createSlice({
  name: 'announcement',
  initialState,
  reducers: {
    resetState: () => initialState,
    setAnnouncementsHidden: (state, {payload}) => {
      state.announcementsHidden = payload;
      localStorage.setItem('announcements-hidden', JSON.stringify(payload));
    },
  },
  extraReducers: {
    [getAnnouncements.fulfilled]: (state, {payload}) => {
      state.announcements = payload;
    },
  },
});

export const {
  resetState,
  setAnnouncementsHidden,
} = slice.actions;

export default slice.reducer;
